
namespace RecordShield.Administration {
    import fld = TenantDetailsRow.Fields;
    @Serenity.Decorators.registerClass()
    export class TenantDetailsGrid extends Serenity.EntityGrid<TenantDetailsRow, any> {
        protected getColumnsKey() { return 'Administration.TenantDetails'; }
        protected getDialogType() { return TenantDetailsDialog; }
        protected getLocalTextPrefix() { return TenantDetailsRow.localTextPrefix; }
        protected getService() { return TenantDetailsService.baseUrl; }
        private PurchasedJournal;
        constructor(container: JQuery) {
            super(container);
        }

        protected getQuickFilters() {
            //debugger;
            var filters = super.getQuickFilters();

            // we create a date-range quick filter, which is a composite
            // filter with two date time editors
           
            var RegistrationDate = this.dateRangeQuickFilter('RegistrationDate', 'Registration Date');

            // need to override its handler, as default date-range filter will set Criteria parameter of list request.
            // we need to set StartDate and EndDate custom parameters of our CustomerGrossSalesListRequest
            RegistrationDate.handler = args => {

                // args.widget here is the start date editor. value of a date editor is a ISO date string
                var start = args.widget.value;

                // to find end date editor, need to search it by its css class among siblings
                var end = args.widget.element.nextAll('.s-DateEditor')
                    .getWidget(Serenity.DateEditor).value;

                (args.request as TenantDetailListRequest).StartDate = start;
                (args.request as TenantDetailListRequest).EndDate = end;

                // active option controls when a filter editor looks active, e.g. its label is blueish
                args.active = !Q.isEmptyOrNull(start) || !Q.isEmptyOrNull(end);
            };

            filters.push(RegistrationDate);

            return filters;
        }

        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            buttons.push(RecordShield.Common.ExcelExportHelper.createToolButton({
                grid: this,
                onViewSubmit: () => this.onViewSubmit(),
                service: 'Administration/TenantDetails/ListExcel',
                separator: true
            }));
            return buttons;
           
        }
    }
}